import { atom } from "recoil";

export const authProfile = atom({
  key: 'authentication',
  default: '',
});

export const advertisementState = atom({
  key: 'advertisements',
  default: []
})

export const campaignsState = atom({
  key: 'campaigns',
  default: []
})

export const eventsState = atom({
  key: 'events',
  default: []
})